import {
  DateParameter,
  type SearchValues,
  useAssignQueryParameter,
  useUpdateQueryParams,
  useWithDefault,
} from '@pba/react-router';
import { useCallback, useMemo } from 'react';
import type { CalendarSetting } from 'features/calendar';
import type { CalendarPageSearchParams } from './types';

type P = {
  dateKey?: string;
  layoutKey?: string;
  modeKey?: string;
};

export const useCalendarSearchParams = ({ dateKey = 'date' }: P = {}): CalendarPageSearchParams => {
  const { assignValue: setDate, value: date } = useAssignQueryParameter(
    dateKey,
    useWithDefault<Date>(DateParameter, new Date()),
  );

  const updateQueryParams = useUpdateQueryParams();

  const createSettingUrlUpdates = useCallback(
    (filterUpdates: Partial<CalendarSetting>) => {
      const urlUpdates: SearchValues = {};

      setDate({ newValue: filterUpdates.date, object: urlUpdates });

      return urlUpdates;
    },
    [setDate],
  );

  const updateSearchParams = useCallback(
    (filter: Partial<CalendarSetting>) => {
      const urlUpdates = createSettingUrlUpdates(filter);
      updateQueryParams({ navigateOptions: { replace: true }, urlUpdates });
    },
    [createSettingUrlUpdates, updateQueryParams],
  );

  return useMemo(() => ({ date, updateSearchParams }), [date, updateSearchParams]);
};
